import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'react-bootstrap';

import { getCompaniesList } from '../../store/selectors';
import { setSelectedCompanyThunk } from '../../store/thunks/companiesThunk';
import { companyTitles } from '../../constants/companies';

function CompanySelector({ title }) {
  const dispatch = useDispatch();

  const companiesList = useSelector(getCompaniesList);
  const dataTitle = companyTitles[title];
  const changeSelected = (selectedCompanyInn) => {
    dispatch(setSelectedCompanyThunk(selectedCompanyInn));
  };

  if (companiesList.length > 0) {
    const currentCompany =
      companiesList.find((company) => company.checked) || companiesList[0];

    return (
      <>
        <div className="company-item-title">
          {typeof dataTitle === 'string' && dataTitle}
        </div>
        <Form.Select
          size="sm"
          onChange={(event) => changeSelected(event.target.value)}
          value={currentCompany.edrpou_inn}
        >
          {companiesList.map((company) => (
            <option key={company.edrpou_inn} value={company.edrpou_inn}>
              {company.company_name || company.edrpou_inn}
            </option>
          ))}
        </Form.Select>
      </>
    );
  }
}

export default CompanySelector;
